

module.exports = __webpack_require__.stylable.create(
    "TabsCategories3410255597",
    {"classes":{"root":"TabsCategories3410255597__root"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    4,
    "TabsCategories3410255597",
    null
);
